import {
  useSmartListById,
  useSmartListFilterDraft,
} from 'features/smart-lists';
import React from 'react';
import { useParams } from 'react-router';

import { PageTopBar } from './components/page-top-bar';
import { SmartListTasksOverview } from './components/tasks-overview';
import * as Styled from './smart-list-detail.style';

export const SmartListDetail: React.FC = () => {
  const scrollContainerRef = React.useRef<HTMLDivElement>(null);
  const { id } = useParams();
  const smartList = useSmartListById(id);
  const {
    defaultFilterDocument,
    activeFilterDocument,
    persistViewPreference,
    updateFilterDocument,
    save: onUpdateSmartList,
    reset: resetUpdatedFilterDocument,
  } = useSmartListFilterDraft(smartList);

  const showCompleted = activeFilterDocument?.showCompleted ?? false;

  const onToggleShowCompleted = () =>
    persistViewPreference({ showCompleted: !showCompleted });

  if (!smartList || !activeFilterDocument) {
    return null;
  }

  return (
    <Styled.Container>
      <Styled.Main>
        <Styled.MainContent>
          <PageTopBar
            showCompleted={showCompleted}
            onToggleShowCompleted={onToggleShowCompleted}
            filterDocument={activeFilterDocument}
            defaultFilterDocument={defaultFilterDocument}
            onUpdateFilterDocument={updateFilterDocument}
            onResetFilter={resetUpdatedFilterDocument}
            onUpdateSmartList={onUpdateSmartList}
          />
          <Styled.Content ref={scrollContainerRef}>
            <SmartListTasksOverview
              scrollElement={scrollContainerRef}
              smartList={smartList}
              filterDocument={activeFilterDocument}
              onReset={resetUpdatedFilterDocument}
            />
          </Styled.Content>
        </Styled.MainContent>
      </Styled.Main>
    </Styled.Container>
  );
};
